(function () {
  'use strict';

  var $ = function(sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };

  var root = $('.cfg-maiko');
  if (!root) return;

  var TIPO_PRODUCTO = root.dataset.productTipo;
  var WA_NUMERO = root.dataset.whatsappNumero;
  var PRODUCT_TITLE = $('.cfg-maiko__titulo').textContent.trim();

  var DIMENSIONES = {
    'EL': {
      alto: [200, 240],
      ancho: [120, 150, 200, 240],
      fondo: [30, 60, 100],
      niveles: [3, 4, 5]
    },
    'ESP_01': {
      alto: [200, 240, 300, 500],
      ancho: [120, 150, 240],
      fondo: [60, 100, 120],
      niveles: [2, 3, 4, 5, 6]
    },
    'ESP_02': {
      alto: [200, 240, 300],
      ancho: [120, 150, 240],
      fondo: [60, 100, 120],
      niveles: [2, 3, 4, 5]
    },
    'EP_01': {
      alto: [300, 600, 900, 1200],
      ancho: [120, 150, 240],
      fondo: [60, 80, 100, 120],
      niveles: [3, 4, 5, 6, 7, 8]
    },
    'EP_02': {
      alto: [240, 300, 600, 900],
      ancho: [120, 150, 240],
      fondo: [60, 100, 120],
      niveles: [2, 3, 4, 5, 6]
    }
  };

  var state = {
    variantes: [],
    seleccion: { alto: null, ancho: null, fondo: null, niveles: null, tendido: 'galvanizada' },
    cantidad: 1
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    state.variantes = window.MAIKO_VARIANTES || [];

    // ============ DIAGNOSTICO ============
    console.log('[MAIKO DEBUG] Tipo producto:', TIPO_PRODUCTO);
    console.log('[MAIKO DEBUG] Total variantes cargadas:', state.variantes.length);
    console.log('[MAIKO DEBUG] SKUs disponibles:', state.variantes.map(function(v) { return v.sku; }));
    var preferida = TIPO_PRODUCTO + '_200_200_60_3';
    console.log('[MAIKO DEBUG] Buscando preferida:', preferida);
    var encontrada = buscarVariante(preferida);
    console.log('[MAIKO DEBUG] Variante encontrada?:', encontrada ? 'SI - precio: ' + encontrada.price : 'NO');
    // =====================================

    renderSelectores();
    bindEventos();
    seleccionPorDefecto();
    actualizar();
  }

  function buscarVariante(ref) {
    for (var i = 0; i < state.variantes.length; i++) {
      if (state.variantes[i].sku === ref) {
        return state.variantes[i];
      }
    }
    return null;
  }

  function getPrecio(variante) {
    var p = variante.price;
    if (typeof p === 'string') p = parseFloat(p);
    return p / 100;
  }

  function renderSelectores() {
    var dims = DIMENSIONES[TIPO_PRODUCTO];
    if (!dims) {
      dims = { alto: [200, 240, 300], ancho: [120, 150, 240], fondo: [60, 100], niveles: [3, 4, 5] };
    }
    ['alto', 'ancho', 'fondo', 'niveles'].forEach(function(dim) {
      var cont = $('#cfg-' + dim);
      if (!cont) return;
      cont.innerHTML = '';
      dims[dim].forEach(function(val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cfg-maiko__pill';
        btn.dataset.dim = dim;
        btn.dataset.valor = val;
        btn.textContent = val;
        cont.appendChild(btn);
      });
    });
  }

  function bindEventos() {
    root.addEventListener('click', function(e) {
      var pill = e.target.closest('.cfg-maiko__pill');
      if (pill && !pill.classList.contains('is-disabled')) {
        state.seleccion[pill.dataset.dim] = parseInt(pill.dataset.valor, 10);
        actualizar();
      }
    });
    $$('input[name="tendido"]').forEach(function(r) {
      r.addEventListener('change', function(e) {
        state.seleccion.tendido = e.target.value;
        actualizar();
      });
    });
    $$('.cfg-maiko__cantidad-btn').forEach(function(b) {
      b.addEventListener('click', function(e) {
        var input = $('#cfg-cantidad');
        var v = parseInt(input.value, 10) || 1;
        v += (e.target.dataset.action === 'mas' ? 1 : -1);
        v = Math.max(1, Math.min(99, v));
        input.value = v;
        state.cantidad = v;
        actualizar();
      });
    });
    var inputCant = $('#cfg-cantidad');
    if (inputCant) {
      inputCant.addEventListener('change', function(e) {
        state.cantidad = Math.max(1, parseInt(e.target.value, 10) || 1);
        e.target.value = state.cantidad;
        actualizar();
      });
    }
    $$('.cfg-maiko__thumb').forEach(function(t) {
      t.addEventListener('click', function() {
        $$('.cfg-maiko__thumb').forEach(function(x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        $('#cfg-render').src = t.dataset.image;
      });
    });
    var btnComprar = $('#cfg-comprar');
    if (btnComprar) btnComprar.addEventListener('click', onComprarClick);
    var btnAsesor = $('#cfg-asesor');
    if (btnAsesor) btnAsesor.addEventListener('click', onAsesorClick);
  }

  function seleccionPorDefecto() {
    // FORZADO: arrancar SIEMPRE en 200_200_60_3 para Liviana
    if (TIPO_PRODUCTO === 'EL') {
      state.seleccion.alto = 200;
      state.seleccion.ancho = 200;
      state.seleccion.fondo = 60;
      state.seleccion.niveles = 3;
      console.log('[MAIKO DEBUG] Seleccion forzada para EL: 200/200/60/3');
      return;
    }

    var dims = DIMENSIONES[TIPO_PRODUCTO];
    if (!dims) dims = { alto: [200], ancho: [120], fondo: [60], niveles: [3] };
    state.seleccion.alto = dims.alto[0];
    state.seleccion.ancho = dims.ancho[0];
    state.seleccion.fondo = dims.fondo[0];
    state.seleccion.niveles = dims.niveles[0];
  }

  function actualizar() {
    ['alto', 'ancho', 'fondo', 'niveles'].forEach(function(dim) {
      $$('.cfg-maiko__pill[data-dim="' + dim + '"]').forEach(function(p) {
        p.classList.toggle('is-active', parseInt(p.dataset.valor, 10) === state.seleccion[dim]);
      });
    });
    var ref = construirRef();
    var refEl = $('#cfg-ref');
    if (refEl) refEl.textContent = ref;
    var variante = buscarVariante(ref);
    if (variante) {
      modoComprar(variante);
    } else {
      modoCotizar();
    }
    actualizarCargaTotal();
    cambiarImagenPorNiveles(state.seleccion.niveles);
  }

  function cambiarImagenPorNiveles(niveles) {
    var container = document.getElementById('cfg-niveles-images');
    if (!container) return;
    var targetAlt = 'niveles-' + niveles;
    var img = container.querySelector('img[data-niveles="' + targetAlt + '"]');
    if (img) {
      var render = document.getElementById('cfg-render');
      if (render) render.src = img.src;
    } else {
      var fallback = container.querySelector('img[data-niveles="niveles-3"]');
      if (fallback) {
        var render2 = document.getElementById('cfg-render');
        if (render2) render2.src = fallback.src;
      }
    }
  }

  function construirRef() {
    var s = state.seleccion;
    return TIPO_PRODUCTO + '_' + s.alto + '_' + s.ancho + '_' + s.fondo + '_' + s.niveles;
  }

  function actualizarCargaTotal() {
    var cargaNivelEl = $('#cfg-carga-nivel');
    var cargaTotalEl = $('#cfg-carga-total');
    if (!cargaNivelEl || !cargaTotalEl) return;
    var cargaPorNivel = parseInt(cargaNivelEl.textContent, 10) || 0;
    if (cargaPorNivel > 0) {
      cargaTotalEl.textContent = (cargaPorNivel * state.seleccion.niveles) + ' kg';
    }
  }

  function modoComprar(variante) {
    var precio = getPrecio(variante);
    var total = precio * state.cantidad;
    var precioEl = $('#cfg-precio');
    if (precioEl) {
      precioEl.textContent = formatearPrecio(total);
      precioEl.classList.remove('is-cotizar');
    }
    var iva = $('.cfg-maiko__precio-iva');
    if (iva) iva.style.display = '';
    var msg = $('#cfg-mensaje-cotizar');
    if (msg) msg.hidden = true;
    var cantWrap = $('#cfg-cantidad-wrapper');
    if (cantWrap) cantWrap.hidden = false;
    var compTexto = $('#cfg-comprar-texto');
    if (compTexto) compTexto.textContent = compTexto.getAttribute('data-default') || 'Comprar';
    var btn = $('#cfg-comprar');
    if (btn) {
      btn.classList.remove('cfg-maiko__btn--cotizar');
      btn.disabled = false;
    }
  }

  function modoCotizar() {
    var precioEl = $('#cfg-precio');
    if (precioEl) {
      precioEl.textContent = 'Cotización personalizada';
      precioEl.classList.add('is-cotizar');
    }
    var iva = $('.cfg-maiko__precio-iva');
    if (iva) iva.style.display = 'none';
    var msg = $('#cfg-mensaje-cotizar');
    if (msg) msg.hidden = false;
    var cantWrap = $('#cfg-cantidad-wrapper');
    if (cantWrap) cantWrap.hidden = true;
    var compTexto = $('#cfg-comprar-texto');
    if (compTexto) compTexto.textContent = 'Solicitar cotización';
    var btn = $('#cfg-comprar');
    if (btn) {
      btn.classList.add('cfg-maiko__btn--cotizar');
      btn.disabled = false;
    }
  }

  function onComprarClick() {
    var ref = construirRef();
    var variante = buscarVariante(ref);
    if (variante) {
      agregarAlCarrito(ref, variante);
    } else {
      abrirWhatsApp(ref, 'cotizacion');
    }
  }

  function onAsesorClick() {
    abrirWhatsApp(construirRef(), 'asesor');
  }

  function agregarAlCarrito(ref, variante) {
    var btn = $('#cfg-comprar');
    var compTexto = $('#cfg-comprar-texto');
    var textoOriginal = compTexto ? compTexto.textContent : 'Comprar';
    if (btn) btn.disabled = true;
    if (compTexto) compTexto.textContent = 'Agregando...';
    var s = state.seleccion;
    var properties = {
      'Alto': s.alto + ' cm',
      'Ancho': s.ancho + ' cm',
      'Profundidad': s.fondo + ' cm',
      'Niveles': s.niveles,
      'Tipo de tendido': s.tendido === 'galvanizada' ? 'Lámina galvanizada' : 'Sin lámina'
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variante.id, quantity: state.cantidad, properties: properties }]
      })
    })
    .then(function(resp) {
      if (!resp.ok) throw new Error('Error');
      window.location.href = '/cart';
    })
    .catch(function() {
      alert('No pudimos agregar el producto al carrito. Por favor intenta de nuevo o contáctanos por WhatsApp.');
      if (btn) btn.disabled = false;
      if (compTexto) compTexto.textContent = textoOriginal;
    });
  }

  function abrirWhatsApp(ref, tipo) {
    var s = state.seleccion;
    var tendidoLabel = s.tendido === 'galvanizada' ? 'Lámina galvanizada' : 'Sin lámina (solo perfil)';
    var variante = buscarVariante(ref);
    var mensaje;
    if (tipo === 'cotizacion') {
      mensaje = 'Hola Maiko, quiero cotizar una estantería personalizada:\n\nProducto: ' + PRODUCT_TITLE + '\nReferencia: ' + ref + '\nAlto: ' + s.alto + ' cm\nAncho: ' + s.ancho + ' cm\nProfundidad: ' + s.fondo + ' cm\nNiveles: ' + s.niveles + '\nTendido: ' + tendidoLabel + '\n\nQuedo atento a la cotización, gracias.';
    } else {
      var precioInfo = variante ? '\nPrecio web: ' + formatearPrecio(getPrecio(variante)) : '\nCotización: personalizada';
      mensaje = 'Hola Maiko, quiero hablar con un asesor sobre:\n\nProducto: ' + PRODUCT_TITLE + '\nReferencia: ' + ref + '\n' + s.alto + 'x' + s.ancho + 'x' + s.fondo + ' cm - ' + s.niveles + ' niveles\nTendido: ' + tendidoLabel + precioInfo;
    }
    window.open('https://wa.me/' + WA_NUMERO + '?text=' + encodeURIComponent(mensaje), '_blank', 'noopener');
  }

  function formatearPrecio(valor) {
    return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(valor);
  }

})();
